<template>
  <desktop-checkout v-if="windowSize >= 576"></desktop-checkout>
  <mobile-checkout v-else></mobile-checkout>
</template>

<script>
/* eslint-disable no-console */
import Windowsize from '@/mixins/Windowsize'
import { mapGetters } from 'vuex'

export default {
  name: 'Checkout',
  mixins: [Windowsize],
  watch: {
    cart_items_count: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.$router.replace({
            name: this.brandStoreRoute('store_page'),
            params: {
              ...this.brandStoreParams,
            },
          })
        }
      },
    },
  },
  computed: {
    ...mapGetters(['cart_items_count', 'brandStoreRoute', 'brandStoreParams']),
  },
  components: {
    DesktopCheckout: () =>
      import('@/components/Blocks/Payment/DesktopCheckout.vue'),
    MobileCheckout: () =>
      import('@/components/Blocks/Payment/MobileCheckout.vue'),
  },
}
</script>

<style lang="scss" scoped>
.payments-container {
  width: 60%;
  margin: auto;
  .w92 {
    width: 92%;
    margin-left: auto;
  }
}
</style>
